import * as React from 'react';
import { WebAPI } from '../../../../MedicareProAPI/API/WebAPI';
import StyledModal from '../../StyledModal';
import { UserRepository } from '../../../../MedicareProAPI/Repositories/User/UserRepository';
import { MultiSelectModal } from './MultiSelectModal';
import { SelectMap } from '../../../Utilities/SelectMap';
import { MultiSelect } from './MultiSelect';
import type { Ind } from '../../../../MedicareProAPI/Entities/Ind/Ind';
import { UserContext } from '../../../Context/UserContext';
import { IndRepository } from '../../../../MedicareProAPI/Repositories/Ind/IndRepository';
import type { User } from '../../../../MedicareProAPI/Entities/User/User';

export interface IndProps {
  disabled?: boolean;
  onChange?: (value: Ind) => void;
  value?: Ind;
  include?: Array<string>;
  user?: User;
}

export const IndSearch = (props: IndProps): React.JSX.Element => {
  const [individuals, setInds] = React.useState<Ind[]>(null);
  const [individualsLoading, setIndsLoading] = React.useState<boolean>(false);

  const [abortController, setAbortController] = React.useState<AbortController>();
  const [value, setValue] = React.useState<Ind>();
  const [searchText, setSearchText] = React.useState<string>(null);

  const userData = React.useContext(UserContext);

  const individualRepository = new IndRepository();
  individualRepository.setAccessToken(userData.userAccessToken);

  React.useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  React.useEffect(() => {
    if (searchText) {
      if (abortController) {
        abortController.abort();
      }

      const newAbortController = new AbortController();
      setAbortController(newAbortController);

      const options = {
        limit: 100,
        criteria: null,
        signal: newAbortController.signal,
        include: [],
      };

      if (props.include) {
        options.include = props.include;
      }

      if (props.user) {
        options.criteria = { ownerId: props.user.getUserId(), indName: searchText };
      } else {
        options.criteria = { indName: searchText };
      }

      individualRepository.getInds(options).then((individuals) => {
        setInds(individuals.getItems());
      });
    }
  }, [searchText]);

  const handleOnClick = (individual: Ind) => {
    setInds(null);
    setValue(individual);

    if (props.onChange) {
      props.onChange(individual || null);
    }
  };

  const handleClearValue = () => {
    setValue(null);

    if (props.onChange) {
      props.onChange(null);
    }
  };

  return (
    <>
      <div className="input-group">
        {individuals && individuals.length > 0 && (
          <div
            className="position-absolute border border-secondary border-top-0 w-100 bg-white"
            style={{ zIndex: 500, marginTop: '32px' }}
          >
            {individuals.map((individual) => {
              return (
                <p
                  className="small py-2 px-2 m-0 border-top cp border-secondary text-always-dark"
                  onClick={(e) => handleOnClick(individual)}
                  key={`ind-${individual.getIndId()}`}
                >
                  {individual.getIndName()}
                </p>
              );
            })}
          </div>
        )}

        <div className="form-control border-secondary">
          {value && (
            <>
              <p className="mt-1">
                <a
                  target="_blank"
                  href={`/agent/profileController/index/${value.getIndId()}`}
                  rel="noreferrer"
                >
                  {value.getIndName()}
                </a>
              </p>
              <button
                onClick={handleClearValue}
                className="badge badge-sm bg-secondary border-0 text-white badge position-absolute"
                style={{ right: '10px', top: '10px' }}
              >
                Clear
              </button>
            </>
          )}
          {!value && (
            <input
              placeholder="Search clients"
              type="text"
              style={{ lineHeight: '1.8' }}
              autoComplete="off"
              onChange={(e) => setSearchText(e.target.value)}
              className="form-control border-0 w-100 d-block p-0 h-auto"
            />
          )}
        </div>
      </div>
    </>
  );
};
